import { apiClient } from '_app'
import { CancelToken } from 'axios'
import { ApiResponse } from 'dtos'
import { NeedsToBeSentOutgoingDto, NeedsToBeSentOutgoingQueryParams } from 'dtos/toDoLists/michiganTitles'
import { URIQuery } from 'utils'

const baseUrl = (): string => `/api/to-do-lists/michigan-titles/needs-to-be-sent-outgoing`

export const getToDoList = (queryParams: NeedsToBeSentOutgoingQueryParams, cancelToken?: CancelToken) =>
  apiClient.get<ApiResponse<NeedsToBeSentOutgoingDto[]>>(baseUrl() + URIQuery(queryParams), { cancelToken }).then(res => res.data)
